module.exports = __webpack_public_path__ + "assets/img/10.8d5532f9.png";